import { Document } from '@graphql/generated';

import { ModalItemType } from './Modal';

type NavigationLike = {
  navigate: (screen: string, params: Record<string, string>) => void;
};

export const buildRenameMenuItem = (
  title: string,
  activeDocument: Document | undefined,
  navigation: NavigationLike
): ModalItemType => ({
  title,
  iconName: 'Edit',
  disable: !activeDocument?.id,
  onSelect: () => {
    if (!activeDocument?.id) return;

    navigation.navigate('rename-file-modal', {
      documentId: activeDocument.id,
      currentName: activeDocument.name ?? '',
    });
  },
});

type WebRenameCallbacks = {
  setRenameValue: (value: string) => void;
  setRenameExtension: (value: string) => void;
  setRenameError: (value: string | undefined) => void;
  setShowRenameModal: (value: boolean) => void;
};

export const buildWebRenameOnSelect = (
  activeDocument: Document | undefined,
  callbacks: WebRenameCallbacks
) => {
  return () => {
    const fullName = activeDocument?.name ?? '';
    const lastDotIndex = fullName.lastIndexOf('.');
    const hasExtension = lastDotIndex > 0;
    const baseName = hasExtension
      ? fullName.substring(0, lastDotIndex)
      : fullName;
    const extension = hasExtension ? fullName.substring(lastDotIndex) : '';
    callbacks.setRenameValue(baseName);
    callbacks.setRenameExtension(extension);
    callbacks.setRenameError(undefined);
    callbacks.setShowRenameModal(true);
  };
};
